import styled from 'styled-components'
import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'
import { COLOR } from 'ggx-componentlibrary/design/color/color.constants'
import {
  FONT_SIZE,
  FONT_REGULAR,
  LINE_HEIGHT,
} from 'ggx-componentlibrary/design/typography/typography.constants'
import { InputStyles } from 'ggx-componentlibrary/components/text-field/text-field.component.styles'
import IconPlusSVG from './icon-plus.svg'
import IconVerticalArrowSVG from './icon-vertical-arrow.svg'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  ${InputStyles}
  ${FONT_REGULAR}
  font-size: ${FONT_SIZE.MEDIUM};
  line-height: ${LINE_HEIGHT.MEDIUM};
  height: auto;
  padding: 12px 16px;
  row-gap: 12px;
  &:has(textarea:focus) {
    border-color: ${COLOR.BLUE_MEDIUM};
  }
`

const StyledTextArea = styled.textarea`
  border: none;
  padding: 0;
  font-size: ${FONT_SIZE.MEDIUM};
  line-height: ${LINE_HEIGHT.MEDIUM};
  color: ${COLOR.BLACK};
  white-space: pre-line;
  height: auto;
  resize: none;
  width: 100%;
  overflow: hidden;
  ${props => (props.error ? `caret-color: ${COLOR.RED_MEDIUM};` : '')}
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const TemplateContainer = styled.div`
  width: calc(100% - 50px - 16px);
  display: flex;
`

const TemplateList = styled.div`
  width: calc(100% - 8px - 8px);
  display: flex;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 8px;
  align-items: center;
  > * {
    cursor: pointer;
  }
  overflow: hidden;
  height: ${props => (props.isExpand ? 'auto' : '16px')};
`

const TemplateItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  white-space: nowrap;
  > * {
    white-space: nowrap;
  }
`

const StyledIconPlus = styled(IconPlusSVG)`
  width: 8px;
  height: 8px;
`

const StyleCounter = styled(SmallText)`
  display: inline-block;
  margin-left: 16px;
  margin-bottom: 0;
  text-align: right;
`

const StyledIconVerticalArrow = styled(IconVerticalArrowSVG)`
  margin-left: 8px;
  width: 8px;
  height: 16px;
  transform: ${props => (props.isExpand ? 'scale(1, 1)' : 'scale(1, -1)')};
  cursor: pointer;
`

export {
  Container,
  StyledTextArea,
  Footer,
  TemplateContainer,
  TemplateList,
  TemplateItem,
  StyledIconPlus,
  StyledIconVerticalArrow,
  StyleCounter,
}
